export default __webpack_public_path__ + "static/media/filter_icon_all_blue.00472e58.svg";